/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.COLORS = [
// eCharts default colors
  '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc',

// Google chart colors
  '#3366cc', '#dc3912', '#ff9900', '#109618', '#990099',
  '#3b3eac', '#0099c6', '#dd4477', '#66aa00', '#b82e2e',
  '#316395', '#994499', '#22aa99', '#aaaa11', '#6633cc',
  '#e67300', '#8b0707', '#329262', '#5574a6', '#3b3eac',

// Other colors
  '#003366', '#339900', '#ff0033', '#000066', '#009900', '#ff0000', '#000000',
  '#336699', '#66cc33', '#cc3399', '#333399', '#33cc33', '#cc3333', '#333333',
  '#6699cc', '#99ff33', '#ff3399', '#6666cc', '#33ff33', '#ff3333', '#999999',
  '#99ccff', '#ccff00', '#990066', '#9999ff', '#00ff00', '#990000', '#cccccc'
];

//###############################################################
// Utility functions
//###############################################################

root.getBoundsZoomLevel = function(bounds, mapDiv) {
  const mapDim = {
    height: mapDiv.height() || ($(window).height() / 2),
    width: mapDiv.width() || ($(window).width() / 2)
  };

  const latRad = function(lat) {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  };

  const zoom = (mapPx, worldPx, fraction) => Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);

  const WORLD_DIM = {
    height: 256,
    width: 256
  };

  const ZOOM_MAX = 21;
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();
  const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
  const lngDiff = ne.lng() - sw.lng();
  const lngFraction = (((lngDiff < 0) ? (lngDiff + 360) : lngDiff)) / 360;
  const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
  const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
  return Math.min(latZoom, lngZoom, ZOOM_MAX);
};

const getPolygonBounds = function(polygon) {
  const path = polygon.getPath();
  let xMin = undefined;
  let yMin = undefined;
  let xMax = undefined;
  let yMax = undefined;
  let i = 0;
  while (i < path.getLength()) {
    var latLng = path.getAt(i);
    var x = latLng.lng();
    var y = latLng.lat();
    if ((undefined === xMin) || (x < xMin)) {
      xMin = x;
    }
    if ((undefined === yMin) || (y < yMin)) {
      yMin = y;
    }
    if ((undefined === xMax) || (x > xMax)) {
      xMax = x;
    }
    if ((undefined === yMax) || (y > yMax)) {
      yMax = y;
    }
    i++;
  }
  return new google.maps.LatLngBounds(new google.maps.LatLng(yMin, xMin), new google.maps.LatLng(yMax, xMax));
};

const coordinatesToPaths = coordinates => $.map(coordinates, ring => $.map(ring, point => new google.maps.LatLng(point[1], point[0])));

root.latLngToString = latLng => "[" + latLng.lng() + "," + latLng.lat() + "]";

//###############################################################
// General functions
//###############################################################

root.initializeMap = function(mapDiv) {
  let mapOptions;
  const bounds = mapDiv.data('bounds');
  if ((undefined !== bounds) && (bounds.length > 1)) {
    const latLngBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(bounds[1][1], bounds[1][0]),
      new google.maps.LatLng(bounds[0][1], bounds[0][0]));
    mapOptions = {
      center: latLngBounds.getCenter(),
      zoom: getBoundsZoomLevel(latLngBounds, mapDiv),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false
    };
  } else {
    mapOptions = {
      center: new google.maps.LatLng(38.95, -96.30),
      zoom: 3,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false
    };
  }
  return new google.maps.Map(mapDiv[0], mapOptions);
};

//###############################################################
// Polygon functions
//###############################################################

root.initializePolygonMap = function() {
  const mapDiv = $('#polygon-map');
  const editable = mapDiv.data('editable') !== undefined;
  const isMultiPolygon = mapDiv.data('multi-polygon') !== undefined;
  const isMultiPolygons = mapDiv.data('multi-polygons') !== undefined;

  const polygonMap = initializeMap(mapDiv);

  drawPolygonOverlays(polygonMap, editable, isMultiPolygon);
  drawExtraPolygons(polygonMap, editable, isMultiPolygons);

  const polygonPath = polygonMap?.polygon?.getPath()?.getLength();
  if (!polygonPath && editable && !isMultiPolygon) {
    addHelp(polygonMap);
  }

  const form = mapDiv.closest('form');
  if (form != null) {
    form.submit(function() {
    if (editable) {
      loadPolygonCoordinates(polygonMap, form.find("input[name$='[polygon_coordinates]']"));
    }
    return true;
  });
  }

  return polygonMap;
};

root.drawPolygonOverlays = function(map, editable, isMultiPolygon) {
  let color, fill;
  const mapDiv = $(map.getDiv());
  const coordinates = mapDiv.data('polygon');
  const has_extra_polygons = mapDiv.data('polygons') !== undefined;
  if (editable) {
    color = '#f00';
    fill = '#f00';
  } else {
    if (has_extra_polygons) {
      color = '#999';
    } else {
      color = '#333';
    }

    fill = '#aaa';
  }

  if (coordinates) {
    const polygonOptions = {
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: fill,
      fillOpacity: 0.3,
      editable // Edit an imported multipolygon is so expensive to render in the browser!!!
    };

    if (isMultiPolygon) {
      const polygons = new GeoJSON({ type: 'MultiPolygon', coordinates }, polygonOptions);
      map.polygons = polygons;
      $.each(polygons, (n, polygon) => polygon.setMap(map));
    } else {
      const paths = coordinatesToPaths(coordinates);
      map.polygon = new google.maps.Polygon($.extend(polygonOptions, {paths}));
      map.polygon.setMap(map);

      if (paths.length > 0) {
        const bounds = getPolygonBounds(map.polygon);
        map.setCenter(bounds.getCenter());
        const zoom = getBoundsZoomLevel(bounds, $(map.getDiv()));
        map.setZoom(zoom);
      }
    }
  }

  if (editable) {
    map.polyline = new google.maps.Polyline({
      strokeColor: '#ff0000',
      strokeOpacity: 1.0,
      strokeWeight: 2
    });
    return map.polyline.setMap(map);
  }
};

var drawExtraPolygons = function(map, editable, isMultiPolygons) {
  const mapDiv = $(map.getDiv());
  let polygons = mapDiv.data('polygons');
  const names = mapDiv.data('polygons_names');
  const counts = mapDiv.data('counts');
  const highlight = mapDiv.data('highlight') !== undefined;
  // Copy rather than unshift onto COLORS: Turbo keeps window across visits, so
  // mutating the global shifts every segment color on later pages.
  const colors = highlight ? ['#f00', ...COLORS] : COLORS;

  if (polygons) {
    return $.each(polygons, function(n, pair) {
      let polygon;
      let name = pair[0];
      if (counts && counts[name]) {
        name += " (" + counts[name] + ")";
      }
      const coordinates = pair[1];
      const center = pair[2];
      const color = (name && !editable && colors[n]) || "#777";
      const polygonOptions = {
        strokeColor: color,
        strokeOpacity: (highlight && (n > 0)) ? 0.3 : 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: (highlight && (n > 0)) ? 0.2 : 0.35,
        zIndex: name && !editable ? n + 1 : 0
      };

      if (isMultiPolygons) {
        polygons = new GeoJSON({ type: 'MultiPolygon', coordinates }, polygonOptions);
        $.each(polygons, function(n, polygon) {
          polygon.setMap(map);
          if (name && !editable) {
            return attachPolygonInfoWindow(polygon, name, map);
          }
        });

      } else {
        const paths = coordinatesToPaths(coordinates);
        polygon = new google.maps.Polygon($.extend(polygonOptions, {paths}));
        polygon.setMap(map);
        if (name && !editable) {
          attachPolygonInfoWindow(polygon, name, map);
        }
      }

      if ((n === 0) && editable) {
        if (isMultiPolygons) {
          return $.each(polygons, (n, polygon) => google.maps.event.addListener(polygon, 'click', event => addLatLng(event, map)));
        } else {
          return google.maps.event.addListener(polygon, 'click', event => addLatLng(event, map));
        }
      }
    });
  }
};

var attachPolygonInfoWindow = function(polygon, label, map) {
    polygon.infoWindow = new google.maps.InfoWindow({
      content: "<span class='info-window'>" + label + "</span>",
      disableAutoPan: true,
      align: 'center',
      pixelOffset: new google.maps.Size(0, -5)
    });
    google.maps.event.addListener(polygon, 'mouseover', function(e) {
      polygon.highlight = true;
      polygon.setOptions({fillOpacity: 0.15, strokeOpacity: 1});
      polygon.infoWindow.setPosition(e.latLng);
      return polygon.infoWindow.open(map);
    });
    google.maps.event.addListener(polygon, 'mousemove', function(e) {
      polygon.highlight = true;
      polygon.setOptions({fillOpacity: 0.15, strokeOpacity: 1});
      polygon.infoWindow.setPosition(e.latLng);
      return polygon.infoWindow.open(map);
    });
    return google.maps.event.addListener(polygon, 'mouseout', function() {
      polygon.highlight = false;
      return setTimeout((function() {
        if (!polygon.highlight) {
          polygon.setOptions({fillOpacity: 0.35, strokeOpacity: 0.8});
          return polygon.infoWindow.close();
        }

      }), 20);
    });
  };

root.addPolygonEvents = function(map, editable) {
  if (editable && map.polyline) { //and !map.polygon
    google.maps.event.addListener(map, 'click', event => addLatLng(event, map));
  }
  return $('#reset-polygon, .reset-polygon').click(() => resetPolygon(map));
};

var addLatLng = function(event, map) {
  const {
    polyline
  } = map;
  const path = polyline.getPath();
  path.push(event.latLng);

  if (map.info != null) {
    map.info.close();
  }

  // Add a new marker at the new plotted point on the polyline.
  if (path.getLength() === 1) {
    map.marker = new google.maps.Marker({
      position: event.latLng,
      title: "Click here to complete polygon",
      map,
      clickable: true,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeColor: '#F00',
        strokeWeight: 1,
        fillColor: 'white',
        fillOpacity: 0.8,
        scale: 4
      }
    });

    google.maps.event.addListener(map.marker, "click", event => completePolygon(event, map));

    if (!map.info) { map.info = new google.maps.InfoWindow(); }
    map.info.setContent("<p>Continue clicking on the map to add segments</p><p>Click this marker to close the polygon</p>");
    return map.info.open(map, map.marker);
  } else {
    if (!map.markers) { map.markers = []; }
    return map.markers.push(new google.maps.Marker({
      position: event.latLng,
      map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeColor: '#F00',
        strokeWeight: 1,
        strokeOpacity: 0.5,
        fillColor: 'white',
        fillOpacity: 0.5,
        scale: 4
      }
    })
    );
  }
};

var completePolygon = function(event, map) {
  const path = map.polyline.getPath();
  const first = path.getAt(0);

  if (map.info != null) {
    map.info.close();
  }

  if (path.getLength() < 3) {
    let s;
    if (path.getLength() === 1) {
      s = 'two more locations';
    } else {
      s = 'one more location';
    }
    map.info.setContent("<p><strong>A location group polygon requires at least three sides.</strong></p>" +
        "<p>Please click on at least " + s + " on the map before clicking here to close the polygon</p>");
    return map.info.open(map, map.marker);
  } else {
    path.push(first);
    if (!map.polygon) {
      map.polygon = new google.maps.Polygon({
        paths: path,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        editable: true
      });
    } else {
      map.polygon.setPaths(path);
    }
    map.polygon.setMap(map);

    map.info.setContent("<p><strong>You can now adjust your polygon.</strong></p>" +
        "<p>To move any corner, simply click and drag the dot at the corner.</p>" +
        "<p>To create a new corner, click and drag the dot in the middle of any side of the polygon.</p>");
    map.info.setPosition(map.marker.position);
    map.info.open(map);

    map.polyline.setMap(null);

    map.marker.setMap(null);
    map.marker = null;

    if (map.markers) { for (var marker of Array.from(map.markers)) { marker.setMap(null); } }
    map.markers = null;

    return google.maps.event.clearListeners(map, 'click');
  }
};

root.resetPolygon = function(map) {
  if (map.polygon != null) {
    map.polygon.setMap(null);
  }
  $.each(map.polygons, (n, polygon) => polygon.setMap(null));

  if (map.polyline != null) {
    map.polyline.getPath().clear();
  }
  if (map.polyline != null) {
    map.polyline.setMap(map);
  }

  if (map.marker != null) {
    map.marker.setMap(null);
  }
  map.marker = null;

  if (map.markers) { for (var marker of Array.from(map.markers)) { marker.setMap(null); } }
  map.markers = null;

  if (map.info != null) {
    map.info.close();
  }

  google.maps.event.clearListeners(map, 'click');
  return google.maps.event.addListener(map, 'click', event => addLatLng(event, map));
};

root.resetBounds = function(map) {
  if (map.rectangle != null) {
    map.rectangle.setMap(null);
  }
  map.corners = [];

  if (map.marker != null) {
    map.marker.setMap(null);
  }
  map.marker = null;

  if (map.markers) { for (var marker of Array.from(map.markers)) { marker.setMap(null); } }
  map.markers = null;

  if (map.info != null) {
    map.info.close();
  }

  google.maps.event.clearListeners(map, 'click');

  return google.maps.event.addListener(map, 'click', event => addCorner(event, map));
};

var loadPolygonCoordinates = function(map, polygonField) {
  let s;
  if (map.polygon) {
    const path = map.polygon.getPath();
    s = pathToPolygonString(path);
    polygonField.val(s);
  } else if (map.polygons) {
    const polygons = [];
    for (var polygon of Array.from(map.polygons)) {
      polygons.push(pathToPolygonString(polygon.getPath()));
    }

    s = "[" + polygons.join(',') + "]";
    polygonField.val(s);
  }
};

var pathToPolygonString = function(path) {
  const points = [];
  let i = 0;
  while (i < path.getLength()) {
    var latLng = path.getAt(i);
    var ll = latLngToString(latLng);
    points.push(ll);
    i++;
  }
  const s = "[" + points.join(',') + "]";
  return s;
};

var addHelp = function(polygonMap) {
  const contentString = "<div id='polygon-info-content'>" +
    "<div id='polygon-info-header'>" +
    "<h1>How to draw a polygon</h1>" +
    "</div>" +
    "<div id='polygon-info-body'>" +
    "<p>Click on the map to draw.  Each click will add a new segment to the polygon. To close the polygon, click the marker for the first point.</p>" +
    "<p>Once you close the polygon, you will be able to make adjustments or even create new segments.</p>" +
    "<p>Start over at any time by clicking the 'Reset Polygon' button</p>" +
    "<p id='polygon-call-to-action'><a id='polygon-call-to-action-button' class='small radius button' onclick='closeInfo()'>Get Started</a></p>" +
    "</div>" +
    "</div>";

  const infoWindow = new google.maps.InfoWindow({
    content: contentString,
    position: polygonMap.getCenter()
  });
  polygonMap.info = infoWindow;
  return infoWindow.open(polygonMap);
};

root.closeInfo = function() {
  const infoWindow = root.polygonMap.info;
  return infoWindow.close();
};

//###############################################################
// Init functions
//###############################################################

/*
$(function() {
  if ($('#polygon-map:visible').length && ($('#polygon-map').data('hidden') !== 'hidden')) {
    return root.polygonMap = initializePolygonMap();
  }
});
*/

function initMapsOnLoad() {
  if ($('#polygon-map:visible').length && ($('#polygon-map').data('hidden') !== 'hidden')) {
    return root.polygonMap = initializePolygonMap();
  }
}

$(initMapsOnLoad);
document.addEventListener('turbo:load', initMapsOnLoad);
